import React from 'react';
import { NSGPTCard } from 'bricks';
import { InvestmentHighlightsData, GPTCheckboxItem } from '../../../types';
import { useGPTCheckboxManager } from '../../../hooks/useGPTCheckboxManager';
import { useInvestmentMemoContext } from '../../../InvestmentMemoContext';

interface InvestmentHighlightsFormProps {
    data: InvestmentHighlightsData;
    onChange: (data: Partial<InvestmentHighlightsData>) => void;
    isLoading?: boolean;
    aiSuggestions?: GPTCheckboxItem[];
}

const InvestmentHighlightsForm = ({
    data, onChange, isLoading = false, aiSuggestions = [],
}: InvestmentHighlightsFormProps) => {
    const { shouldShowError, getFieldError } = useInvestmentMemoContext();
    const {
        allItems,
        handleCheckboxCheck,
        handleAddCustomItem,
        handleDeleteCheckbox,
        handleEditCheckbox,
    } = useGPTCheckboxManager({
        currentItems: data.highlights || [],
        aiSuggestions,
        onChange: items => onChange({ highlights: items }),
    });

    return (
        <div className="px-3 pb-3">
            <NSGPTCard
                label="Highlights to include"
                checkboxContent={allItems}
                onCheckboxCheck={handleCheckboxCheck}
                onDeleteCheckbox={handleDeleteCheckbox}
                onEditCheckbox={handleEditCheckbox}
                shouldAddCustomSection
                customSectionButtonLabel="Add custom highlight"
                customNamePlaceholder="Highlight name"
                customDescriptionPlaceholder="Highlight description"
                onCustomItemAdd={handleAddCustomItem}
                isLoading={isLoading}
                loadingMessage="Generating highlights..."
            />
            {!isLoading && shouldShowError('investmentHighlights.highlights') && (
                <p className="text-danger small mt-1 mb-0">
                    {getFieldError('investmentHighlights.highlights')}
                </p>
            )}
        </div>
    );
};
export default InvestmentHighlightsForm;
